<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">

        <div class="flex flex-col overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl "> Benutzer Übersicht</span>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row w-full">
            <div class="w-full ">
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Benutzername</span>
                <input class="border p-2 rounded w-3/4" v-model="user.login" data-ui="username-input">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Name</span>
                <input class="border p-2 rounded w-3/4" v-model="user.name" data-ui="surename-input">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">E-Mail</span>
                <input class="border p-2 rounded w-3/4" v-model="user.mail" data-ui="email-input">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Telefon</span>
                <input class="border p-2 rounded w-3/4" v-model="user.phone" data-ui="phonenumber-input">
              </div>
              <div class="flex grid-cols-3 w-full gap-2 mt-2">
                <button data-ui="administrator"
                    class="w-full px-4 py-2  hover:bg-trader-blue hover:text-white rounded"
                    :class="selectedRole === 1 ? 'bg-green-500' : 'bg-trader-gray'"
                    @click="setRole(1)">
                  Administrator
                </button>
                <button data-ui="marketing"
                    class="px-4 w-full py-2 rounded  hover:bg-trader-blue hover:text-white"
                    :class="selectedRole === 0 ? 'bg-green-500' : 'bg-trader-gray'"
                    @click="setRole(0)">
                  Marketing
                </button>
                <button data-ui="purchaser"
                    class="px-4 w-full py-2  rounded  hover:bg-trader-blue hover:text-white"
                    :class="selectedRole === 15 ? 'bg-green-500' : 'bg-trader-gray'"
                    @click="setRole(15)">
                  Einkäufer
                </button>
              </div>
              <div class="flex">
                <button @click="deleteTrue" class=" mr-1 w-full rounded mt-2 p-3 bg-primary hover:bg-trader-red hover:text-white transition duration-200 ease-in-out" data-ui="delete-user-button">Benutzer Löschen</button>
                <a :href="'/api/v3/impersonate/' + userId" class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" data-ui="impersonate-this-user">
                  Mit diesem Benutzer Einloggen</a>
              </div>
              <button @click="editUser" class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-green hover:text-white transition duration-200 ease-in-out" data-ui="save-user-changes-button">Speichern</button>

              <div class="flex items-center justify-between h-10 mt-6 mb-2 w-full rounded">
                <div class="w-full bg-primary p-2 rounded">
                  <span class="text-xl">Passwort ändern</span>
                </div>
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Neues Passwort</span>
                <input type="password" autocomplete="new-password" class="border p-2 rounded w-3/4" v-model="newPassword" data-ui="new-password-input">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Wiederholen</span>
                <input type="password" autocomplete="new-password" class="border p-2 rounded w-3/4" v-model="newPasswordAgain" data-ui="repeat-new-password-input">
              </div>
              <div v-if="passwordError" class="mt-2 text-red-500" data-ui="password-error-notice">{{ passwordError }}</div>
              <button @click="editUserPassword" class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-green hover:text-white transition duration-200 ease-in-out" data-ui="save-user-password-button">Passwort setzen</button>
            </div>
          </div>

          <div class="flex flex-col mt-4 flex-grow overflow-hidden  min-h-[300px]">

            <div class="  bg-primary p-1 rounded">
              <h1 class="text-xl "> Einkaufsbereiche</h1>
            </div>

            <div class="flex flex-col w-full flex-grow bg-white overflow-auto border rounded mt-2 p-1">
              <select multiple class="flex-grow " v-model="selectedTeamIds" data-ui="selected-purchaser">
                <option class="p-2" :value="team.id" v-for="team in teams ">{{team.tag}} - {{ team.name }}</option>
              </select>
            </div>

          </div>
        </div>

      </div>
    </div>

    <sidebar />
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "../../../apolloClient";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import ProductFormular from "@/components/ProductFormular/ProductFormular.vue";
import Accordion from "@/components/Accordion/Accordion.vue";
import ProductHeader from "@/components/ProductFormular/ProductHeader.vue";
import PageGrid from "@/components/PageGrid/PageGrid.vue";
import router from "@/router";
import sidebar from "@/components/Administration/Sidebar.vue";
import {eventBus} from "@/application/EventBus";
import SignalBus from "@/application/SignalBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {CGoBack, sidebar, ProductHeader, Accordion, ProductFormular, AccordionItem, PageGrid},
  data() {
    return {
      userId: null,
      showUser: true,
      selectedRole: 0,
      userData: {
        user: [],
      },
      teams: [],
      selectedTeamIds: [],
      user: {
        fetchedUser: "",
      },
      accordionIndex: 0,
      newPassword: "",
      newPasswordAgain: "",
      passwordError: "",
    };
  },

  methods: {
    setRole(role) {
      this.selectedRole = role;
    },
    deleteTrue( ) {
      eventBus.openConfirm({
        title: "User",
        message: "Möchten Sie diesen User wirklich löschen?",
        onAccept: () => {
          this.deleteUser();
        }
      });
    },
    goBack(){
      router.push(`/administration`);
    },
    async deleteUser(){
      const mutation = gql`
        mutation deleteUser($userId: Int!) {
          deleteUser(userId: $userId) {
            success
          }
        }
      `;

      try {
        const variables = {
          userId: this.userId
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if(data.deleteUser.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "User gelöscht",
            message: "Der User wurde gelöscht.",
          });
          router.push(`/administration/${this.accordionIndex}`);
        }
      } catch (error) {
        console.error(error);
      }
    },
      async editUser() {
        const userData = {
          userID: this.userId,
          name: this.user.name,
          login: this.user.login,
          mail: this.user.mail,
          phone: this.user.phone,
          selectedTeamIds: this.selectedTeamIds,
          role: this.selectedRole
        };
        const mutation = gql`
        mutation editUser($user: UserInputEdit!) {
          editUser(user: $user) {
            success
          }
        }
      `;
        try {
          const variables = {
            user: userData
          };
          const {data} = await apolloClient.mutate({mutation, variables});
          if(data.editUser && data.editUser.success) {
            eventBus.openModal(SuccessConfirmation);
            eventBus.setData({
              title: "User gespeichert",
              message: "Der User wurde gespeichert.",
            });
          }
        } catch (error) {
          console.error("Daten konnten nicht geupdatet werden ", error);
        }

      },
    async editUserPassword() {
      this.passwordError = "";
      if (!this.newPassword) {
        this.passwordError = "Bitte ein neues Passwort eingeben.";
        return;
      }
      if (this.newPassword !== this.newPasswordAgain) {
        this.passwordError = "Passwörter stimmen nicht überein.";
        return;
      }
      const mutation = gql`
        mutation editUserPassword($userId: Int!, $password: String!) {
          editUserPassword(userId: $userId, password: $password) {
            success
          }
        }
      `;
      try {
        const variables = {
          userId: Number(this.userId),
          password: this.newPassword
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.editUserPassword && data.editUserPassword.success) {
          this.newPassword = "";
          this.newPasswordAgain = "";
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Passwort geändert",
            message: "Das Passwort wurde geändert.",
          });
        }
      } catch (error) {
        const reason = error?.graphQLErrors?.[0]?.message || error?.networkError?.message || error?.message;
        this.passwordError = reason ? `Passwort konnte nicht geändert werden: ${reason}` : "Passwort konnte nicht geändert werden.";
        console.error("Passwort konnte nicht geändert werden ", error);
      }
    },
    async getUser() {
      try {
        const response = await apolloClient.query({
          query: gql`
                query GetUser ($userId: Int!) {
                    getUser (userId:$userId) {
                      userId
                      userName
                      login
                      lastUpdateTimestamp
                      language
                      userMail
                      userPhone
                      purchasingIds
                      role
                    }
                }
            `,
          variables: {
            userId: this.userId
          }
        });
        const fetchedUser = response.data.getUser;
        this.user.data = response.data.getUser;// Speichern aller Daten
        this.user.name = fetchedUser.userName;
        this.user.userId = fetchedUser.userId;
        this.user.lastUpdateTimestamp = fetchedUser.lastUpdateTimestamp;
        this.user.language = fetchedUser.language;
        this.user.mail = fetchedUser.userMail;
        this.user.phone = fetchedUser.userPhone;
        this.user.login = fetchedUser.login;
        this.selectedRole = fetchedUser.role;
        //this.user.purchasingIds = fetchedUser.purchasingIds;

        this.selectedTeamIds = [];
        fetchedUser.purchasingIds.forEach(item => {
          this.selectedTeamIds.push(item);
        })
      } catch (error) {
        console.error("Fehler beim Abrufen der Userdaten:", error);
      }
    },
    async getTeams() {
      try {
        const response = await apolloClient.query({
          query: gql`
                query GetTeam {
                    teams  {
                     tag
                     id
                     name
                    }
                }
            `,
        });
        const teamData = response.data.teams;
        if (teamData.length > 0) {

          this.teams  = teamData
        }

      } catch (error) {
        console.error("Fehler beim Abrufen der Userdaten:", error);
      }
    }
  },
  mounted() {
    this.userId = this.$route.params.userId;
    this.getUser();
    this.getTeams();
    SignalBus.connect(this,"delete-user", this.deleteUser);
    SignalBus.emit("Headline-user");
  },
  beforeUnmount() {
     SignalBus.disconnectAllFromParent(this);
  },
  watch: {
    '$route.params.userId': function (newId, oldId) {
      this.userId = newId;
      this.newPassword = "";
      this.newPasswordAgain = "";
      this.passwordError = "";
      this.getUser();
      this.getTeams();
    },
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  created() {
    if(this.$route.params.userId != null && typeof this.$route.params.userId != 'undefined' && this.$route.params.userId != '' ){
      this.userId = this.$route.params.userId;
      this.getUser();
      this.getTeams();
    }
    this.accordionIndex = this.$route.params.accordionIndex;
  }
};
</script>
